// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Spice = require("@greenlabs/ppx-spice/src/rescript/Spice.bs.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Util_Logger = require("../util/Util_Logger.bs.js");
var Images = require("@artegeie/page-constants/dist/images");
var ZoneTypes = require("@artegeie/page-constants/dist/zoneTypes");
var VideoTypes = require("@artegeie/page-constants/dist/videoTypes");

function displayError(scope, value) {
  Util_Logger.error2(scope + (": " + value), "This constant is not defined");
}

var scope = "Zone.Layout";

function decode(x) {
  if (x === ZoneTypes.ZONE_LAYOUT_EVENT) {
    return /* Event */0;
  } else if (x === ZoneTypes.ZONE_LAYOUT_HORIZONTAL) {
    return /* Horizontal */1;
  } else if (x === ZoneTypes.ZONE_LAYOUT_HORIZONTAL_FIRST_HIGHLIGHTED) {
    return /* Horizontal_First_Highlited */2;
  } else if (x === ZoneTypes.ZONE_LAYOUT_SINGLE) {
    return /* Single */4;
  } else if (x === ZoneTypes.ZONE_LAYOUT_SLIDER) {
    return /* Slider */5;
  } else if (x === ZoneTypes.ZONE_LAYOUT_TABLEVIEW) {
    return /* TableView */6;
  } else if (x === ZoneTypes.ZONE_LAYOUT_VERTICAL) {
    return /* Vertical */7;
  } else if (x === ZoneTypes.ZONE_LAYOUT_VERTICAL_FIRST_HIGHLIGHTED) {
    return /* PaginatedList */3;
  } else {
    displayError(scope, x);
    return /* Slider */5;
  }
}

var Layout = {
  scope: scope,
  decode: decode
};

var scope$1 = "Zone.Item_Template";

var pageHeader = Belt_Option.getWithDefault((ZoneTypes.ITEM_TEMPLATE_PAGE_HEADER == null) ? undefined : Caml_option.some(ZoneTypes.ITEM_TEMPLATE_PAGE_HEADER), "pageHeader");

var ebuBox = "ebu-box";

function decode$1(x) {
  if (x === ZoneTypes.ZONE_TYPE_BANNER) {
    return /* Banner */0;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_COLLECTION_CONTENT) {
    return /* ContentCollection */1;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_LABEL) {
    return /* Label */4;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_LANDSCAPE) {
    return /* Landscape */5;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_LANDSCAPE_BIG) {
    return /* LandscapeBig */6;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_LANDSCAPE_BIG_WITH_SUBTITLE) {
    return /* LandscapeBigWithSubtitle */7;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_LANDSCAPE_GENRE) {
    return /* LandscapeGenre */8;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_GUIDE) {
    return /* Guide */3;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_NEWSLETTER) {
    return /* Newsletter */9;
  } else if (x === pageHeader) {
    return /* PageHeader */10;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_PARTNER) {
    return /* Partner */11;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_PLAYNEXT) {
    return /* PlayNext */12;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_PORTRAIT) {
    return /* Portrait */13;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_POSTER) {
    return /* Poster */14;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_PROGRAM_CONTENT) {
    return /* ProgramContent */15;
  } else if (x === Images.FORMAT_SQUARE) {
    return /* Square */16;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_TEXT_ON_LEFT_SIDE) {
    return /* TextOnLeftSide */17;
  } else if (x === ZoneTypes.ITEM_TEMPLATE_TEXT_ON_RIGHT_SIDE) {
    return /* TextOnRightSide */18;
  } else if (x === ebuBox) {
    return /* EbuBox */2;
  } else {
    displayError(scope$1, x);
    return /* Landscape */5;
  }
}

var Item_Template = {
  scope: scope$1,
  pageHeader: pageHeader,
  ebuBox: ebuBox,
  decode: decode$1
};

var _map = {"ebu-box":"ebu-box","event-textOnLeftSide":"event-textOnLeftSide","event-textOnRightSide":"event-textOnRightSide","horizontal-landscape":"horizontal-landscape","horizontal-landscapeBig":"horizontal-landscapeBig","horizontal-landscapeBigWithSubtitle":"horizontal-landscapeBigWithSubtitle","horizontal-landscape-genre":"horizontal-landscape-genre","horizontal-portrait":"horizontal-portrait","horizontal-poster":"horizontal-poster","horizontal-square":"horizontal-square","horizontalFirstHighlighted-square":"horizontalFirstHighlighted-square","horizontalSelectedHighlighted-landscape":"horizontalSelectedHighlighted-landscape","single-banner":"single-banner","single-collectionContent":"single-collectionContent","single-newsletter":"single-newsletter","single-pageHeader":"single-pageHeader","single-partner":"single-partner","single-programContent":"single-programContent","slider-banner":"slider-banner","slider-landscape":"slider-landscape","slider-square":"slider-square","tableview-guide":"tableview-guide","tableview-playnext":"tableview-playnext","vertical-label":"vertical-label","vertical-landscape":"vertical-landscape","verticalFirstHighlighted-landscape":"verticalFirstHighlighted-landscape"};

function tToJs(param) {
  return param;
}

function tFromJs(param) {
  return _map[param];
}

function toItemTemplate(t) {
  if (t === "single-programContent") {
    return /* ProgramContent */15;
  } else if (t === "single-collectionContent") {
    return /* ContentCollection */1;
  } else if (t === "single-banner" || t === "slider-banner") {
    return /* Banner */0;
  } else if (t === "horizontal-poster") {
    return /* Poster */14;
  } else if (t === "horizontal-square" || t === "horizontalFirstHighlighted-square" || t === "slider-square") {
    return /* Square */16;
  } else if (t === "vertical-landscape" || t === "tableview-guide" || t === "horizontalSelectedHighlighted-landscape" || t === "slider-landscape" || t === "horizontal-landscape" || t === "verticalFirstHighlighted-landscape") {
    return /* Landscape */5;
  } else if (t === "horizontal-landscapeBig") {
    return /* LandscapeBig */6;
  } else if (t === "horizontal-portrait") {
    return /* Portrait */13;
  } else if (t === "single-partner") {
    return /* Partner */11;
  } else if (t === "vertical-label") {
    return /* Label */4;
  } else if (t === "single-pageHeader") {
    return /* PageHeader */10;
  } else if (t === "ebu-box") {
    return /* EbuBox */2;
  } else if (t === "event-textOnRightSide") {
    return /* TextOnRightSide */18;
  } else if (t === "tableview-playnext") {
    return /* PlayNext */12;
  } else if (t === "single-newsletter") {
    return /* Newsletter */9;
  } else if (t === "horizontal-landscape-genre") {
    return /* LandscapeGenre */8;
  } else if (t === "horizontal-landscapeBigWithSubtitle") {
    return /* LandscapeBigWithSubtitle */7;
  } else {
    return /* TextOnLeftSide */17;
  }
}

var Template = {
  tToJs: tToJs,
  tFromJs: tFromJs,
  toItemTemplate: toItemTemplate
};

var scope$2 = "Zone.DataKeys";

function decode$2(x) {
  if (x === "program_recommendations") {
    return /* ProgramRecommendations */0;
  } else if (x === "program_categoryMostViewed") {
    return /* ProgramMostViewedCategory */1;
  } else {
    displayError(scope$2, x);
    return /* NotRecognized */2;
  }
}

var DataKeys = {
  scope: scope$2,
  decode: decode$2
};

var Zone = {
  Layout: Layout,
  Item_Template: Item_Template,
  Template: Template,
  DataKeys: DataKeys
};

var scope$3 = "VideoTypes";

function t_encode(v) {
  switch (v) {
    case /* MostViewed */0 :
        return ["MostViewed"];
    case /* LastChance */1 :
        return ["LastChance"];
    case /* MostRecent */2 :
        return ["MostRecent"];
    case /* AudioDescription */3 :
        return ["AudioDescription"];
    case /* Magazines */4 :
        return ["Magazines"];
    
  }
}

function t_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a variant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a variant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AudioDescription" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AudioDescription */3
                  };
          }
      case "LastChance" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* LastChance */1
                  };
          }
      case "Magazines" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Magazines */4
                  };
          }
      case "MostRecent" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MostRecent */2
                  };
          }
      case "MostViewed" :
          if (tagged.length !== 1) {
            return Spice.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MostViewed */0
                  };
          }
      default:
        
    }
  }
  return Spice.error(undefined, "Invalid variant constructor", Belt_Array.getExn(json_arr$1, 0));
}

function encode(x) {
  switch (x) {
    case /* MostViewed */0 :
        return VideoTypes.MOST_VIEWED;
    case /* LastChance */1 :
        return VideoTypes.LAST_CHANCE;
    case /* MostRecent */2 :
        return VideoTypes.MOST_RECENT;
    case /* AudioDescription */3 :
        return VideoTypes.AUDIO_DESCRIPTION;
    case /* Magazines */4 :
        return VideoTypes.MAGAZINES;
    
  }
}

function decode$3(x) {
  if (x === VideoTypes.MOST_VIEWED) {
    return /* MostViewed */0;
  } else if (x === VideoTypes.LAST_CHANCE) {
    return /* LastChance */1;
  } else if (x === VideoTypes.MOST_RECENT) {
    return /* MostRecent */2;
  } else if (x === VideoTypes.AUDIO_DESCRIPTION) {
    return /* AudioDescription */3;
  } else if (x === VideoTypes.MAGAZINES) {
    return /* Magazines */4;
  } else {
    displayError(scope$3, x);
    return ;
  }
}

var VideoTypes$1 = {
  scope: scope$3,
  t_encode: t_encode,
  t_decode: t_decode,
  encode: encode,
  decode: decode$3
};

exports.displayError = displayError;
exports.Zone = Zone;
exports.VideoTypes = VideoTypes$1;
/* pageHeader Not a pure module */
